import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _extends from "@babel/runtime/helpers/esm/extends";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import CSSTransitionGroup from 'react-transition-group/CSSTransitionGroup';
import classNames from 'classnames';
import { Button } from 'module-tsl-ui-elements';
import { getUuidv4, setId, processMenuItem, areAllSiblingsChecked, setInitialState } from './helpers';

var renderMenuItem = function renderMenuItem(params) {
  var item = params.item,
      goNext = params.goNext,
      setChecked = params.setChecked,
      breadCrumbs = params.breadCrumbs,
      checkedItems = params.checkedItems,
      onClickedItem = params.onClickedItem,
      radio = params.radio;
  var label = item.label,
      children = item.children;
  var hasChildren = Array.isArray(children) && children.length > 0;
  var toDisplay = hasChildren && breadCrumbs.filter(function (bc) {
    return bc.id === item.id;
  }).length > 0;
  var isChecked = item.resetAll && checkedItems.length === 0 ? 0 : checkedItems.map(function (_ref) {
    var id = _ref.id;
    return id;
  }).indexOf(item.id);
  var checkedChild = hasChildren && checkedItems.filter(function (ci) {
    return ci.ancestors.map(function (_ref2) {
      var id = _ref2.id;
      return id;
    }).indexOf(item.id) > -1;
  }).length > 0;
  var props = item.href ? {
    href: item.href,
    onClick: function onClick(evt) {
      return onClickedItem(evt, item, isChecked);
    }
  } : {
    onClick: function onClick(evt) {
      onClickedItem(evt, item, isChecked);

      if (hasChildren) {
        goNext(item);
      } else {
        setChecked(item, radio);
      }
    }
  };
  var cName = classNames({
    'is-reset-all': item.resetAll,
    'is-check-all': item.checkAll,
    'has-btn-checked': isChecked > -1
  });
  var cNameBtn = classNames({
    'btn--has-children': hasChildren,
    'btn--is-checkable': !hasChildren,
    'btn--is-checked': isChecked > -1,
    'btn--has-checked-children': checkedChild
  });
  var cNameUl = classNames('smart-nav__list smart-nav__list--nested', {
    'smart-nav__list--displayed': toDisplay
  });
  return /*#__PURE__*/React.createElement("li", {
    key: item.id,
    className: cName
  }, /*#__PURE__*/React.createElement(Button, _extends({
    theme: "tertiary",
    className: cNameBtn
  }, props), /*#__PURE__*/React.createElement("span", null, label)), hasChildren && /*#__PURE__*/React.createElement("ul", {
    className: cNameUl,
    "data-parent-id": item.id
  }, children.map(function (menuItem) {
    return renderMenuItem(_objectSpread(_objectSpread({}, params), {}, {
      item: menuItem,
      radio: !!item.radio
    }));
  })));
};

renderMenuItem.displayName = "renderMenuItem";

var SmartNav = /*#__PURE__*/function (_Component) {
  _inherits(SmartNav, _Component);

  var _super = _createSuper(SmartNav);

  function SmartNav(props) {
    var _this;

    _classCallCheck(this, SmartNav);

    _this = _super.call(this, props);
    _this.menuItemsProcessed = props.menu.map(setId).map(function (toProcess) {
      return processMenuItem(props.disableCheckAll)(toProcess, []);
    });

    if (props.resetAll) {
      _this.menuItemsProcessed.unshift({
        label: props.resetAll,
        resetAll: true,
        // this does the trick!
        id: getUuidv4()
      });
    }

    _this.state = _objectSpread({}, setInitialState(props, _this.menuItemsProcessed));
    _this.committedState = _objectSpread({}, _this.state);
    return _this;
  }

  _createClass(SmartNav, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.setCurrentMenuHeight();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      var _this2 = this;

      if (prevState.open !== this.state.open && this.state.open) {
        if (this.props.onOpen) this.props.onOpen();
        this.setState(_objectSpread(_objectSpread({}, this.committedState), {}, {
          open: true
        }), function () {
          return _this2.setCurrentMenuHeight();
        }); // eslint-disable-line
      } else {
        this.setCurrentMenuHeight();
      }

      if (prevState.open !== this.state.open && !this.state.open) {
        if (this.props.onClose) this.props.onClose();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this._to) clearTimeout(this._to);
    }
  }, {
    key: "setCurrentMenuHeight",
    value: function setCurrentMenuHeight() {
      var _this$state = this.state,
          breadCrumbs = _this$state.breadCrumbs,
          minHeight = _this$state.minHeight;
      var last = breadCrumbs.length > 0 ? breadCrumbs[breadCrumbs.length - 1] : null;
      var currentHeightElement = last && this._domElement ? this._domElement.querySelector("[data-parent-id=\"".concat(last.id, "\"]")) : this._domElement; // needs a check otherwise will loop... as it's being called on componentDidUpdate
      // so it's needed to avoid infinite recursion!

      if (currentHeightElement && currentHeightElement.offsetHeight !== minHeight && currentHeightElement.offsetHeight > 0) {
        this.setState({
          minHeight: currentHeightElement.offsetHeight
        });
      }
    }
  }, {
    key: "setChecked",
    value: function setChecked(item) {
      var radio = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var _this$state2 = this.state,
          breadCrumbs = _this$state2.breadCrumbs,
          checkedItems = _this$state2.checkedItems;
      var multipleBranchSelection = this.props.multipleBranchSelection;
      var checkedItemIndex = checkedItems.map(function (_ref3) {
        var id = _ref3.id;
        return id;
      }).indexOf(item.id); // so we can remove it

      if (item.resetAll) {
        return this.setState({
          checkedItems: []
        });
      }

      if (checkedItemIndex === -1) {
        // add it
        // if multipleBranchSelection is true, its simple as we just push stuff...
        // otherwise, we have to check what items are not on the same
        // branch (i.e. their breadcrumbs differ) and remove them
        if (radio) {
          // just check self and don't care about the siblings
          return this.setState({
            checkedItems: [item]
          });
        }

        var finalMenuItems = multipleBranchSelection ? _toConsumableArray(checkedItems) : checkedItems.filter(function (checkedItem) {
          var currentBreadCrumbLevel = breadCrumbs.map(function (_ref4) {
            var id = _ref4.id;
            return id;
          }).join('');
          var checkedItemBreadCrumbLevel = checkedItem.ancestors.map(function (_ref5) {
            var id = _ref5.id;
            return id;
          }).join('');
          return currentBreadCrumbLevel === checkedItemBreadCrumbLevel;
        });
        var finalMenuItemsIds = finalMenuItems.map(function (_ref6) {
          var id = _ref6.id;
          return id;
        });
        var allSiblingsChecked = areAllSiblingsChecked(item, finalMenuItems, 1);
        var itemsForCheckAll = item.checkAll ? item.toCheck : []; // if ALL the siblings are checked, add also back the checkAll item.

        var finalCheckedItems = [].concat(_toConsumableArray(finalMenuItems), _toConsumableArray(itemsForCheckAll.filter(function (_ref7) {
          var id = _ref7.id;
          return finalMenuItemsIds.indexOf(id) === -1;
        })), [// filter away items already there
        _objectSpread({}, item)]);
        this.setState({
          checkedItems: allSiblingsChecked ? [].concat(_toConsumableArray(finalCheckedItems), [_objectSpread({}, item.toUncheck[0])]) : finalCheckedItems
        });
      } else {
        // remove it
        var uncheckIds = item.toUncheck ? [item.id].concat(_toConsumableArray(item.toUncheck.map(function (_ref8) {
          var id = _ref8.id;
          return id;
        }))) : [item.id];
        var filteredItems = checkedItems.filter(function (_ref9) {
          var id = _ref9.id;
          return uncheckIds.indexOf(id) === -1;
        });
        this.setState({
          checkedItems: filteredItems
        });
      }
    }
  }, {
    key: "resetTitle",
    value: function resetTitle() {
      var _this3 = this;

      if (this._to) clearTimeout(this._to);
      this._to = setTimeout(function () {
        return _this3.setState({
          canRenderTitle: true
        });
      }, 200);
    }
  }, {
    key: "nextLevel",
    value: function nextLevel(item) {
      var _this4 = this;

      var breadCrumbs = this.state.breadCrumbs;
      this.setState({
        breadCrumbs: [].concat(_toConsumableArray(breadCrumbs), [item]),
        canRenderTitle: false,
        direction: 'forwards'
      }, function () {
        return _this4.resetTitle();
      });
    }
  }, {
    key: "prevLevel",
    value: function prevLevel() {
      var _this5 = this;

      var breadCrumbs = this.state.breadCrumbs;
      this.setState({
        breadCrumbs: breadCrumbs.slice(0, breadCrumbs.length - 1),
        canRenderTitle: false,
        direction: 'backwards'
      }, function () {
        return _this5.resetTitle();
      });
    }
  }, {
    key: "commitAndClose",
    value: function commitAndClose() {
      this.committedState = _objectSpread({}, this.state);
      if (this.props.onDone) this.props.onDone(this.state.checkedItems.filter(function (_ref10) {
        var checkAll = _ref10.checkAll;
        return !checkAll;
      }));
      this.setState({
        open: false
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this6 = this;

      var _this$state3 = this.state,
          open = _this$state3.open,
          breadCrumbs = _this$state3.breadCrumbs,
          canRenderTitle = _this$state3.canRenderTitle,
          checkedItems = _this$state3.checkedItems,
          direction = _this$state3.direction,
          minHeight = _this$state3.minHeight;
      var committedCheckedItems = this.committedState.checkedItems;
      var _this$props = this.props,
          initialTitle = _this$props.initialTitle,
          buttonProps = _this$props.buttonProps,
          theme = _this$props.theme,
          disableFullScreen = _this$props.disableFullScreen,
          disableCheckAll = _this$props.disableCheckAll,
          onClickedItem = _this$props.onClickedItem,
          keepOpen = _this$props.keepOpen;
      var currentTitle = breadCrumbs.length > 0 ? breadCrumbs[breadCrumbs.length - 1].label : initialTitle;
      var committedCheckedItemsLength = committedCheckedItems.filter(function (_ref11) {
        var checkAll = _ref11.checkAll;
        return !checkAll;
      }).length;
      var disabledCommit = committedCheckedItems.map(function (_ref12) {
        var id = _ref12.id;
        return id;
      }).join('') === checkedItems.map(function (_ref13) {
        var id = _ref13.id;
        return id;
      }).join('');
      var mainClass = classNames('smart-nav', {
        'smart-nav--not-full-screen': disableFullScreen
      });
      var navListClass = classNames('smart-nav__list', {
        'smart-nav__list--purple': theme === 'purple',
        'smart-nav__list--primary': theme === 'primary'
      });
      return /*#__PURE__*/React.createElement("div", {
        className: mainClass
      }, !keepOpen && /*#__PURE__*/React.createElement(Button, _extends({}, _objectSpread(_objectSpread({}, buttonProps), {}, {
        theme: theme
      }), {
        onClick: function onClick() {
          return _this6.setState({
            open: true
          });
        }
      }), initialTitle, committedCheckedItemsLength > 0 ? " (".concat(committedCheckedItemsLength, ")") : ''), /*#__PURE__*/React.createElement(CSSTransitionGroup, {
        transitionName: "sn-overlay",
        transitionEnterTimeout: 200,
        transitionLeaveTimeout: 200
      }, (open || keepOpen) && /*#__PURE__*/React.createElement("div", {
        className: "smart-nav__overlay"
      }, /*#__PURE__*/React.createElement("header", {
        className: "smart-nav__header"
      }, breadCrumbs.length > 0 && /*#__PURE__*/React.createElement(Button, {
        theme: "tertiary",
        icon: "back",
        onClick: function onClick() {
          return _this6.prevLevel();
        }
      }), /*#__PURE__*/React.createElement("h3", {
        className: "smart-nav__title"
      }, /*#__PURE__*/React.createElement("span", {
        className: "smart-nav__title-item"
      }, /*#__PURE__*/React.createElement(CSSTransitionGroup, {
        transitionName: direction === 'forwards' ? 'sn-title-f' : 'sn-title-b',
        transitionEnterTimeout: 200,
        transitionLeaveTimeout: 200
      }, canRenderTitle && /*#__PURE__*/React.createElement("span", {
        className: "smart-nav__title-animated"
      }, currentTitle)))), !keepOpen && /*#__PURE__*/React.createElement(Button, {
        theme: "tertiary",
        icon: "remove",
        onClick: function onClick() {
          return _this6.setState({
            open: false
          });
        }
      })), /*#__PURE__*/React.createElement("menu", {
        className: "smart-nav__menu",
        style: {
          transform: "translate3d(-".concat(breadCrumbs.length * 100, "%, 0, 0)"),
          minHeight: minHeight + 60
        }
      }, /*#__PURE__*/React.createElement("ul", {
        className: navListClass,
        ref: function ref(element) {
          _this6._domElement = element;
        }
      }, this.menuItemsProcessed.map(function (menuItem) {
        return renderMenuItem({
          item: menuItem,
          breadCrumbs: breadCrumbs,
          checkedItems: checkedItems,
          onClickedItem: onClickedItem,
          goNext: function goNext(item) {
            return _this6.nextLevel(item);
          },
          setChecked: function setChecked(item, radio) {
            return _this6.setChecked(item, radio);
          }
        });
      }))), !disableCheckAll && /*#__PURE__*/React.createElement("footer", {
        className: "smart-nav__footer"
      }, /*#__PURE__*/React.createElement(Button, {
        theme: theme,
        onClick: function onClick() {
          return _this6.commitAndClose();
        },
        disabled: disabledCommit,
        isBlock: true
      }, "Done")))));
    }
  }]);

  return SmartNav;
}(Component);

SmartNav.displayName = "SmartNav";
SmartNav.propTypes = {
  initialTitle: PropTypes.string.isRequired,
  menu: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string.isRequired,
    children: PropTypes.array
  })).isRequired,
  multipleBranchSelection: PropTypes.bool,
  disableCheckAll: PropTypes.bool,
  open: PropTypes.bool,
  keepOpen: PropTypes.bool,
  disableFullScreen: PropTypes.bool,
  buttonProps: PropTypes.shape({
    href: PropTypes.string,
    target: PropTypes.string,
    type: PropTypes.string,
    size: PropTypes.oneOf(['sm', 'md', 'lg', 'xl']),
    isBlock: PropTypes.bool,
    loading: PropTypes.bool
  }),
  onDone: PropTypes.func,
  onClose: PropTypes.func,
  onOpen: PropTypes.func,
  onClickedItem: PropTypes.func,
  resetAll: PropTypes.string,
  theme: PropTypes.string,
  checkedItems: PropTypes.arrayOf(PropTypes.string),
  itemKey: PropTypes.string,
  breadCrumbs: PropTypes.arrayOf(PropTypes.string)
};
SmartNav.defaultProps = {
  multipleBranchSelection: false,
  resetAll: null,
  theme: 'primary',
  itemKey: 'label',
  disableCheckAll: false,
  onClickedItem: function onClickedItem() {},
  open: false,
  keepOpen: false,
  disableFullScreen: false,
  breadCrumbs: [],
  buttonProps: {},
  onDone: function onDone() {},
  onClose: function onClose() {},
  onOpen: function onOpen() {},
  checkedItems: []
};
export default SmartNav;